import Account from '@/helper/AccountHelper.js';
import ConfigManager from '@/config/ConfigManager';
import BzbsApi from '@/core/Http/BzbsApi.js';
import {
    ProfileParamsBuilder,
    AddressParamsBuilder,
    ShippingAddressParamsBuilder
} from '@/core/Account/model/AccountModel.js';

import { map } from 'rxjs/operators';

/**
 * @method getProfile
 * @method getPoint
 * @method updateProfile
 * @method updateShippingAddress
 * @method registerUser
 * @method changePassword
 * @method registerLine
 * @method changeContactNumber
 * @method changeLocale
 */
export default {
    /**
     * Get user profile.
     * @param {object} token
     */
    getProfile: function (token) {
        const url = ConfigManager.getApiUrl() + '/profile/me';
        return BzbsApi.connectBzbsGet(url, token).pipe(map((res) => {
            return res.data;
        }));
    },

    /**
     * Get point.
     * @param {string} token
     */
    getPoint: function (token) {
        const url = ConfigManager.getApiUrl() + '/profile/me/updated_points';
        return BzbsApi.connectBzbsGet(url, token, null)
            .pipe(map((res) => {
                const pointObject = res.data;
                return pointObject;
            }));
    },

    /**
     * Update user profile.
     * @param {string} token
     * @param {object} objProfileInfo
     * @param {object} objProfileAdress
     * @param {string} strExtendJson
     * @param {string} strUploadKey
     * @param {object} objUpload
     */
    updateProfile: function (token, profile, profileAddress, strExtendJson, strUploadKey, objUpload) {
        const profileParams = new ProfileParamsBuilder();
        var params = profileParams.getParams(profile);

        if (profile && profile.merge_extendjsonstring) {
            params.merge_extendjsonstring = profile.merge_extendjsonstring;
        }

        if (profileAddress) {
            const addressParams = new AddressParamsBuilder();
            var addr = addressParams.getParams(profileAddress)
            params = {...params, ...addr};
        }

        if (strExtendJson)
            params.extendjsonstring = strExtendJson;

        const url = ConfigManager.getApiUrl() + '/profile/me';
        return BzbsApi.connectBzbsPost(url, token, params, strUploadKey, objUpload).pipe(map((res) => {
            return res.data;
        }));
    },

    /**
     * Update user shipping address.
     * @param {string} token
     * @param {object} objProfileShippingAddress
     */
    updateShippingAddress: function (token, objProfileShippingAddress) {
        const paramsShipping = new ShippingAddressParamsBuilder();
        const params = paramsShipping.getParams(objProfileShippingAddress);

        const url = ConfigManager.getApiUrl() + '/profile/me/shipping';
        return BzbsApi.connectBzbsPost(url, token, params).pipe(map((res) => {
            return res.data;
        }));
    },

    registerUserWithParams: function(params) {
        params.app_id = ConfigManager.getAppId();

        const url = ConfigManager.getApiUrl() + '/auth/register';
        return BzbsApi.connectBzbsPost(url, null, params, null, null).pipe(map((res) => {
            return res.data;
        }));
    },

    apiValidateRegister: function(params) {
        params.app_id = ConfigManager.getAppId();
        const url = ConfigManager.getApiUrl() + '/auth/validate_register';
        return BzbsApi.connectBzbsPost(url, null, params, null, null).pipe(map((res) => {
            return res.data;
        }));
    },

    registerUser: function (objRegisterModel, haveOTP, objRegisterOTPModel, objRegisterDeviceInfoModel, objRegisterAddressModel, objRegisterOtherInfoModel) {
        var params = {
            app_id: ConfigManager.getAppId(),
        };

        if (!objRegisterModel) {
            return null;
        }

        if (haveOTP && !objRegisterOTPModel) {
            return null;
        }

        //Basic info.
        if (objRegisterModel.strUsername)
            params.username = objRegisterModel.strUsername;

        if (objRegisterModel.strPassword)
            params.password = objRegisterModel.strPassword;

        if (objRegisterModel.strConfirmPassword)
            params.confirmpassword = objRegisterModel.strConfirmPassword;

        if (objRegisterModel.strFirstname)
            params.firstname = objRegisterModel.strFirstname;

        if (objRegisterModel.strLastname)
            params.lastname = objRegisterModel.strLastname;

        if (objRegisterModel.strEmail)
            params.email = objRegisterModel.strEmail;

        if (objRegisterModel.strContactNumber)
            params.contact_number = objRegisterModel.strContactNumber;

        if (objRegisterModel.strBirthDate)
            params.birthdate = objRegisterModel.strBirthDate;

        if (objRegisterModel.strNationalID)
            params.idcard = objRegisterModel.strNationalID;

        if (objRegisterModel.strGender)
            params.gender = objRegisterModel.strGender;

        //OTP.
        if (objRegisterOTPModel) {
            if (objRegisterOTPModel.strOTP)
                params.otp = objRegisterOTPModel.strOTP;

            if (objRegisterOTPModel.strRefCode)
                params.refcode = objRegisterOTPModel.strRefCode;
        }

        //Device info.
        if (objRegisterDeviceInfoModel) {
            if (objRegisterDeviceInfoModel.strCarrier)
                params.carrier = objRegisterDeviceInfoModel.strCarrier;

            if (objRegisterDeviceInfoModel.strClientVersion)
                params.client_version = objRegisterDeviceInfoModel.strClientVersion;

            if (objRegisterDeviceInfoModel.strOperationSystem)
                params.os = objRegisterDeviceInfoModel.strOperationSystem;

            if (objRegisterDeviceInfoModel.strPlatform)
                params.platform = objRegisterDeviceInfoModel.strPlatform;

            if (objRegisterDeviceInfoModel.strMacAddress)
                params.mac_address = objRegisterDeviceInfoModel.strMacAddress;
        }

        if (objRegisterAddressModel) {
            if (objRegisterAddressModel.strAddress)
                params.address = objRegisterAddressModel.strAddress;

            if (objRegisterAddressModel.strZipcode)
                params.zipcode = objRegisterAddressModel.strZipcode;

            if (objRegisterAddressModel.strProvinceCode)
                params.province_code = objRegisterAddressModel.strProvinceCode;

            if (objRegisterAddressModel.strProvinceName)
                params.province_name = objRegisterAddressModel.strProvinceName;

            if (objRegisterAddressModel.strDistrictCode)
                params.district_code = objRegisterAddressModel.strDistrictCode;

            if (objRegisterAddressModel.strDistrictName)
                params.district_name = objRegisterAddressModel.strDistrictName;

            if (objRegisterAddressModel.strSubDistrictCode)
                params.subdistrict_code = objRegisterAddressModel.strSubDistrictCode;

            if (objRegisterAddressModel.strSubDistrictName)
                params.subdistrict_name = objRegisterAddressModel.strSubDistrictName;

            if (objRegisterAddressModel.strLatitude)
                params.latitude = objRegisterAddressModel.strLatitude;

            if (objRegisterAddressModel.strLongitude)
                params.longitude = objRegisterAddressModel.strLongitude;
        }

        if (objRegisterOtherInfoModel) {
            if (objRegisterOtherInfoModel.strInfo)
                params.info = objRegisterOtherInfoModel.strInfo;

            if (objRegisterOtherInfoModel.strCustomInfo)
                params.custom_info = objRegisterOtherInfoModel.strCustomInfo;
        }

        const url = ConfigManager.getApiUrl() + '/auth/register';
        return BzbsApi.connectBzbsPost(url, null, params, null, null).pipe(map((res) => {
            return res.data;
        }));
    },

    /**
     * Change bzbs password
     * @param {string} token
     * @param {string} strCurrent Current password
     * @param {string} strChange New password
     */
    changePassword: function (token, strCurrent, strChange) {
        var params = {
            current: strCurrent,
            change: strChange,
        };

        const url = ConfigManager.getApiUrl() + "/profile/me/change_password";
        return BzbsApi.connectBzbsPost(url, token, params, null, null).pipe(map((res) => {
            return res.data;
        }));
    },

    /**
     * @param {ProfileParamsBuilder} params (required) /core/Account/model/AccountModel.js
     * @param {string} lineIdToken (required)
     * @param {string} refcode (optional)
     * @param {string|number} otp (optional)
     */
    registerLine: function(profileParams, lineIdToken, refcode, otp) {
        var params = profileParams;
        if (lineIdToken) {
            params.id_token = lineIdToken;
        }
        if (refcode && otp) {
            params.refcode = refcode;
            params.otp = otp;
        }
        const url = ConfigManager.getApiUrl() + "/line/register";
        return BzbsApi.connectBzbsPost(url, null, params, null, null).pipe(map((res) => {
            return res.data;
        }));
    },

    /**
     * Change Contact number
     * @param {string} token
     * @param {string} contact_number New contact number
     * @param {string} refcode
     * @param {string} otp
     */
    changeContactNumber: function (token, contact_number, refcode, otp) {
        var params = {
            contact_number: contact_number,
            refcode: refcode,
            otp: otp
        };
        const url = ConfigManager.getApiUrl() + "/profile/me/contact_number";
        return BzbsApi.connectBzbsPost(url, token, params, null, null).pipe(map((res) => {
            return res.data;
        }));
    },

    /**
     * @param {string|number} localeCode
     */
     changeLocale: function (localeCode) {
        let token = Account.getToken();
        let url = ConfigManager.getApiUrl() + '/profile/me/locale';
        let params = {
            locale: localeCode,
        };
        return BzbsApi.connectBzbsPost(url, token, params).pipe(map((res) => {
            return res.data;
        }));
    },
}

